export const USERLOGIN = 'LOGIN'
export const USERLOGOUT = 'LOGOUT'
export const isVerified = 'false'
export const walletConnnected = 'walletConnnected'
